import { render, staticRenderFns } from "./HeroBar.vue?vue&type=template&id=6c4b068b&"
import script from "./HeroBar.vue?vue&type=script&lang=js&"
export * from "./HeroBar.vue?vue&type=script&lang=js&"
import style0 from "./HeroBar.vue?vue&type=style&index=0&id=6c4b068b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports